import React, { useState } from 'react';
import { EntityId } from '@reduxjs/toolkit';

import UserTable from './UserTable';
import UserTableToolbar from './UserTableToolbar';
import { TableViewLayout } from '../../../common/layout/components';
import useDocumentTitle from '../../../../../_config/react/useDocumentTitle';
const UserList = () => {
  const [selectedRows, setSelectedRows] = useState<EntityId[]>([]);
  useDocumentTitle(`MTTP - Utilisateurs`);
  return (
    <>
      <TableViewLayout title="Utilisateurs">
        <UserTableToolbar selectedRows={selectedRows} />
        <UserTable onSelectRows={setSelectedRows} />
      </TableViewLayout>
    </>
  );
};

export default UserList;
